import { PixelCrop } from 'react-image-crop';
import Resizer from 'react-image-file-resizer';

export async function canvasPreview(image: HTMLImageElement, canvas: HTMLCanvasElement, crop: PixelCrop, scale = 1) {
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        throw new Error('No 2d context');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1;

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = 'high';

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    // 4) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY);
    // 3) Move the origin to the center of the original position
    ctx.translate(centerX, centerY);
    // 2) Scale the image
    ctx.scale(scale, scale);
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY);
    // ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);

    ctx.restore();
}

export function toBlob(canvas: HTMLCanvasElement | null): Promise<Blob | null> {
    /* olve(null);
        });return canvas !== null
        ? new Promise((resolve) => {
            canvas.toBlob(resolve);
        })
        : new Promise((resolve) => {
            res 
    */
    return new Promise((resolve) => {
        if (canvas) {
            canvas.toBlob(
                (blob) => {
                    resolve(blob);
                },
                'image/png',
                1.0,
            ); // 1.0 quality
        } else {
            resolve(null);
        }
    });
}

export function blobToFile(blob: Blob, fileName: string): File {
    return new File([blob], fileName, { type: blob.type });
}
export const resizeFile = (file: File, width?: number, height?: number): Promise<File | null> =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            const targetWidth = width || img.width;
            const targetHeight = height || img.height;
            Resizer.imageFileResizer(
                file,
                targetWidth,
                targetHeight,
                'PNG',
                100,
                0,
                /* (uri) => {
                    resolve(uri as string);
                }, */
                async (uri) => {
                    const resizedFile = dataURLtoFile(uri as string, file.name);
                    if (resizedFile && resizedFile.size <= 5 * 1024 * 1024) {
                        resolve(resizedFile);
                    } else {
                        resolve(null);
                    }
                },
                'base64',
            );
        };
        img.onerror = (error) => reject(error);
    });

export const dataURLtoFile = (dataURL: string, filename: string): File | null => {
    const arr = dataURL.split(',');
    if (arr.length !== 2) {
        console.error('Invalid data URL format');
        return null;
    }
    const mimeMatch = arr[0].match(/data:([^;]*);/);
    if (!mimeMatch) {
        console.error('Invalid data URL format');
        return null;
    }
    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
};
